/**
 * Variant Icons — DÉSACTIVÉ : les icônes sont désormais rendues côté serveur
 * via snippets/variant-icon.liquid (plus de flash ni de décalage au re-rendu).
 * Fichier conservé pour ne pas casser la référence asset_url dans theme.liquid.
 */
(function () {
  var icons = {
    'capsule':    '<svg viewBox="0 0 24 24"><ellipse cx="12" cy="6" rx="6" ry="3"/><path d="M6 6v4c0 4 2.7 7.2 6 8 3.3-.8 6-4 6-8V6"/></svg>',
    'capsules':   '<svg viewBox="0 0 24 24"><ellipse cx="12" cy="6" rx="6" ry="3"/><path d="M6 6v4c0 4 2.7 7.2 6 8 3.3-.8 6-4 6-8V6"/></svg>',
    'dosette':    '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/></svg>',
    'dosettes':   '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/></svg>',
    'vrac':       '<svg viewBox="0 0 24 24"><circle cx="8" cy="10" r="3"/><circle cx="16" cy="10" r="3"/><circle cx="12" cy="16" r="3"/></svg>',
    'boite':      '<svg viewBox="0 0 24 24"><path d="M3 8l9-4 9 4v8l-9 4-9-4z"/><path d="M3 8l9 4 9-4"/><path d="M12 12v8"/></svg>',
    'sachet':     '<svg viewBox="0 0 24 24"><path d="M8 2h8l2 6H6zM6 8v12a2 2 0 002 2h8a2 2 0 002-2V8"/></svg>',
    'sachets':    '<svg viewBox="0 0 24 24"><path d="M8 2h8l2 6H6zM6 8v12a2 2 0 002 2h8a2 2 0 002-2V8"/></svg>',
    'mousseline': '<svg viewBox="0 0 24 24"><path d="M8 2h8v4l-2 2 2 2-2 2 2 2v6a2 2 0 01-2 2h-4a2 2 0 01-2-2v-6l2-2-2-2 2-2-2-2z"/></svg>',
    'pyramide':   '<svg viewBox="0 0 24 24"><path d="M12 4L4 20h16z"/><path d="M12 4v16M4 20l8-8 8 8"/></svg>',
    'galette':    '<svg viewBox="0 0 24 24"><ellipse cx="12" cy="14" rx="9" ry="4"/><path d="M3 14v4c0 2 4 4 9 4s9-2 9-4v-4"/><circle cx="12" cy="14" r="2"/></svg>',
    'cake':       '<svg viewBox="0 0 24 24"><ellipse cx="12" cy="14" rx="9" ry="4"/><path d="M3 14v4c0 2 4 4 9 4s9-2 9-4v-4"/><circle cx="12" cy="14" r="2"/></svg>',
    'grains':     '<svg viewBox="0 0 24 24"><circle cx="8" cy="10" r="3"/><circle cx="16" cy="10" r="3"/><circle cx="12" cy="16" r="3"/></svg>',
    'moulu':      '<svg viewBox="0 0 24 24"><circle cx="6" cy="8" r="1.2"/><circle cx="10" cy="6" r="1"/><circle cx="14" cy="8" r="1.2"/><circle cx="18" cy="10" r="1"/><circle cx="8" cy="14" r="1.3"/><circle cx="12" cy="12" r="1"/><circle cx="16" cy="14" r="1.1"/><circle cx="6" cy="18" r="1"/><circle cx="11" cy="18" r="1.2"/><circle cx="17" cy="18" r="1"/></svg>',
    'italienne':  '<svg viewBox="0 0 24 24"><path d="M8 2v4M16 2v4"/><path d="M6 6h12v4l-2 10H8L6 10z"/><path d="M6 10h12"/></svg>',
    'moka':       '<svg viewBox="0 0 24 24"><path d="M8 2v4M16 2v4"/><path d="M6 6h12v4l-2 10H8L6 10z"/><path d="M6 10h12"/></svg>',
    'filtre':     '<svg viewBox="0 0 24 24"><path d="M4 4h16l-3 16H7z"/><path d="M4 4l2 4h12l2-4"/></svg>',
    'v60':        '<svg viewBox="0 0 24 24"><path d="M4 4h16l-6 10v8h-4v-8z"/></svg>',
    'aeropress':  '<svg viewBox="0 0 24 24"><rect x="7" y="3" width="10" height="4" rx="1"/><path d="M8 7v14h8V7"/><path d="M6 21h12"/></svg>',
    'espresso':   '<svg viewBox="0 0 24 24"><path d="M5 10h10v6a4 4 0 01-4 4H9a4 4 0 01-4-4v-6z"/><path d="M15 12h2a2 2 0 010 4h-2"/></svg>',
    'piston':     '<svg viewBox="0 0 24 24"><rect x="6" y="6" width="12" height="14" rx="1"/><line x1="12" y1="2" x2="12" y2="6"/><line x1="9" y1="2" x2="15" y2="2"/><line x1="6" y1="12" x2="18" y2="12"/></svg>',
    'french':     '<svg viewBox="0 0 24 24"><rect x="6" y="6" width="12" height="14" rx="1"/><line x1="12" y1="2" x2="12" y2="6"/><line x1="9" y1="2" x2="15" y2="2"/><line x1="6" y1="12" x2="18" y2="12"/></svg>',
    'syphon':     '<svg viewBox="0 0 24 24"><circle cx="12" cy="6" r="4"/><path d="M10 10v4M14 10v4"/><path d="M8 14h8v4a4 4 0 01-4 4 4 4 0 01-4-4z"/></svg>',
    'turque':     '<svg viewBox="0 0 24 24"><path d="M6 8h8v8a4 4 0 01-4 4 4 4 0 01-4-4z"/><path d="M14 10h4"/></svg>',
    'turc':       '<svg viewBox="0 0 24 24"><path d="M6 8h8v8a4 4 0 01-4 4 4 4 0 01-4-4z"/><path d="M14 10h4"/></svg>',
    'cold brew':  '<svg viewBox="0 0 24 24"><path d="M7 3h10l-1 18H8z"/><path d="M10 8v10M14 8v10"/></svg>',
    'cold-brew':  '<svg viewBox="0 0 24 24"><path d="M7 3h10l-1 18H8z"/><path d="M10 8v10M14 8v10"/></svg>',
    'theiere':    '<svg viewBox="0 0 24 24"><path d="M4 12h13a3 3 0 010 6H4z"/><path d="M17 13l4-3v8l-4-3"/><path d="M8 12V6a2 2 0 114 0v6"/></svg>',
    'infuseur':   '<svg viewBox="0 0 24 24"><path d="M10 4v4M14 4v4"/><path d="M6 8h12v4a6 6 0 01-12 0z"/><circle cx="12" cy="16" r="1"/><circle cx="8" cy="12" r="0.7"/><circle cx="16" cy="12" r="0.7"/></svg>',
    '1 kg':      '<svg viewBox="0 0 24 24"><path d="M8 2h8l2 6H6zM6 8v12a2 2 0 002 2h8a2 2 0 002-2V8"/></svg>',
    '1kg':       '<svg viewBox="0 0 24 24"><path d="M8 2h8l2 6H6zM6 8v12a2 2 0 002 2h8a2 2 0 002-2V8"/></svg>',
    '500g':      '<svg viewBox="0 0 24 24"><path d="M8 2h8l2 6H6zM6 8v12a2 2 0 002 2h8a2 2 0 002-2V8"/></svg>',
    '500':       '<svg viewBox="0 0 24 24"><path d="M8 2h8l2 6H6zM6 8v12a2 2 0 002 2h8a2 2 0 002-2V8"/></svg>',
    '250g':      '<svg viewBox="0 0 24 24"><path d="M8 2h8l2 6H6zM6 8v12a2 2 0 002 2h8a2 2 0 002-2V8"/></svg>',
    '250':       '<svg viewBox="0 0 24 24"><path d="M8 2h8l2 6H6zM6 8v12a2 2 0 002 2h8a2 2 0 002-2V8"/></svg>',
    '200g':      '<svg viewBox="0 0 24 24"><path d="M8 2h8l2 6H6zM6 8v12a2 2 0 002 2h8a2 2 0 002-2V8"/></svg>',
    '200':       '<svg viewBox="0 0 24 24"><path d="M8 2h8l2 6H6zM6 8v12a2 2 0 002 2h8a2 2 0 002-2V8"/></svg>',
    '100g':      '<svg viewBox="0 0 24 24"><path d="M8 2h8l2 6H6zM6 8v12a2 2 0 002 2h8a2 2 0 002-2V8"/></svg>',
    '100':       '<svg viewBox="0 0 24 24"><path d="M8 2h8l2 6H6zM6 8v12a2 2 0 002 2h8a2 2 0 002-2V8"/></svg>'
  };

  // Mots-cles tries du plus specifique au moins specifique
  var keywords = [
    'cold brew', 'cold-brew', 'aeropress', 'mousseline', 'pyramide', 'galette',
    'capsules', 'capsule', 'dosettes', 'dosette', 'boite', 'vrac',
    'sachets', 'sachet', 'cake', 'theiere', 'infuseur',
    '1 kg', '1kg', '500g', '500', '250g', '250', '200g', '200', '100g', '100',
    'italienne', 'moka', 'espresso', 'filtre', 'piston', 'french', 'syphon',
    'turque', 'turc', 'v60', 'grains', 'moulu'
  ];

  // Config depuis metafield JSON (si present)
  var userConfig = {};
  try {
    var el = document.getElementById('variant-icons-config');
    if (el) userConfig = JSON.parse(el.textContent);
  } catch (e) {}

  function findIcon(text) {
    var t = text.toLowerCase();

    // 1) Config utilisateur
    for (var key in userConfig) {
      if (t.indexOf(key.toLowerCase()) !== -1) {
        if (userConfig[key] === 'aucun') return null;
        return icons[userConfig[key]] || null;
      }
    }

    // 2) Auto-detection
    for (var i = 0; i < keywords.length; i++) {
      if (t.indexOf(keywords[i]) !== -1) return icons[keywords[i]] || null;
    }
    return null;
  }

  function inject() {
    var spans = document.querySelectorAll('.variant-option__button-label__text');
    if (!spans.length) return;

    spans.forEach(function (span) {
      if (span.querySelector('.variant-icon')) return;
      var svg = findIcon(span.textContent || '');
      if (svg) {
        var el = document.createElement('span');
        el.className = 'variant-icon variant-icon--builtin';
        el.innerHTML = svg;
        span.insertBefore(el, span.firstChild);
      }
    });
  }

  // Executer des que le DOM est pret
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }

  // Observer les changements (Horizon re-render)
  var timer;
  var obs = new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(inject, 30);
  });

  function observe() {
    var target = document.querySelector('.variant-option, variant-picker, .product-form');
    if (target) obs.observe(target.parentElement || target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
  document.addEventListener('variant:update', function () {
    clearTimeout(timer);
    timer = setTimeout(inject, 50);
  });
})();
